<div class="row" >
    <app-add-patient [renderForm]="renderFrom" [memberIdFromParent]="memberId"></app-add-patient>
</div>